import { CloseOutlined, ReloadOutlined } from "@ant-design/icons";
import { Tag } from "antd-mobile";
import { useTranslation } from "react-i18next";
import filterTypeEnum from "../Filter/enumerations/filterTypeEnum";
import styles from "./style.module.scss";

const FilterTag = ({
  filterSetup = {},
  filterValue = {},
  filterDefaultValue = {},
  setFilterValue = () => {},
  apiValue = {},
  refreshSearch = () => {},
}) => {
  const { t } = useTranslation();
  const { filters } = filterSetup;

  const handleOnReset = () => {
    setFilterValue((prevState) => {
      return { ...filterDefaultValue };
    });
    setTimeout(() => {
      refreshSearch();
    }, 300);
  };

  const onHandleTagClick = (filter) => {
    if (filter.required === false) {
      if (filter.type === filterTypeEnum.DATE_TIME_RANGE) {
        setFilterValue((prevState) => {
          return {
            ...prevState,
            [filter.data_index[0]]: filterDefaultValue[filter.data_index[0]],
            [filter.data_index[1]]: filterDefaultValue[filter.data_index[1]],
          };
        });
      } else {
        setFilterValue((prevState) => {
          return {
            ...prevState,
            [filter.data_index]: filterDefaultValue[filter.data_index],
          };
        });
      }
    }
    refreshSearch();
  };

  const renderTag = (filter) => {
    switch (filter.type) {
      case filterTypeEnum.INPUT: {
        const value = filterValue[filter.data_index];
        if (value) {
          return (
            <Tag key={filter.data_index} className={styles.tag}>
              <div className={styles.tagContainer} onClick={() => onHandleTagClick(filter)}>
                <div>{value}</div>
                {filter.required === false ? <CloseOutlined className={styles.icon} /> : null}
              </div>
            </Tag>
          );
        }
        break;
      }
      case filterTypeEnum.SELECT: {
        switch (filter.data_type) {
          case "grouped": {
            //Recursive call render tag for each group items
            const map = filter.items.map((item) => {
              return renderTag(item);
            });
            return map;
          }
          case "static": {
            const key = filterValue[filter.data_index];
            if (key === null || key === undefined) break;
            const value = filter.value_enum.find((val) => val.value === key);
            let label = value?.label || "";
            if (value && value?.label_tag) {
              label = value?.label_tag;
            }
            return (
              <Tag key={filter.data_index} className={styles.tag}>
                <div className={styles.tagContainer} onClick={() => onHandleTagClick(filter)}>
                  <div>{value?.is_translation === true ? t(label) : label}</div>
                  {filter.required === false ? <CloseOutlined className={styles.icon} /> : null}
                </div>
              </Tag>
            );
          }
          case "api": {
            if (apiValue[filter.data_index].value_enum.length > 0) {
              const key = filterValue[filter.data_index];
              const value = apiValue[filter.data_index].value_enum.find((val) => val.value === key);
              let label = value?.label || "";
              if (value && value?.label_tag) {
                label = value?.label_tag;
              }
              return (
                <Tag key={filter.data_index} className={styles.tag}>
                  <div
                    className={`${styles.tagContainer} ${
                      filter.required === true ? styles.centered : ""
                    }`}
                    onClick={() => onHandleTagClick(filter)}
                  >
                    <div>
                      {value?.is_translation && value?.is_translation === true ? t(label) : label}
                    </div>
                    {filter.required === false ? <CloseOutlined className={styles.icon} /> : null}
                  </div>
                </Tag>
              );
            }
            break;
          }
          default:
            break;
        }
        break;
      }
      case filterTypeEnum.DATE_TIME_RANGE:
        const start_value = filterValue[filter.data_index[0]];
        const end_value = filterValue[filter.data_index[1]];
        if (start_value && end_value) {
          return (
            <Tag key={filter.data_index} className={styles.tag}>
              <div className={styles.tagContainer} onClick={() => onHandleTagClick(filter)}>
                <div className={styles.text}>{`${start_value} ~ ${end_value}`}</div>
                {filter.required === false ? <CloseOutlined className={styles.icon} /> : null}
              </div>
            </Tag>
          );
        }
        break;
      case filterTypeEnum.DROPDOWN_SELECT: {
        switch (filter.data_type) {
          case "grouped": {
            //Recursive call render tag for each group items
            const map = filter.items.map((item) => {
              return renderTag(item);
            });
            return map;
          }
          case "static": {
            const key = filterValue[filter.data_index];
            if (key === null || key === undefined) break;
            const value = filter.value_enum.find((val) => val.value === key);
            let label = value?.label || "";
            if (value && value?.label_tag) {
              label = value?.label_tag;
            }
            return (
              <Tag key={filter.data_index} className={styles.tag}>
                <div className={styles.tagContainer} onClick={() => onHandleTagClick(filter)}>
                  <div>{value.is_translation === true ? t(label) : label}</div>
                  {filter.required === false ? <CloseOutlined className={styles.icon} /> : null}
                </div>
              </Tag>
            );
          }
          case "api": {
            if (apiValue[filter.data_index].value_enum.length > 0) {
              const key = filterValue[filter.data_index];
              const value = apiValue[filter.data_index].value_enum.find((val) => val.value === key);
              let label = value?.label || "";
              if (value && value?.label_tag) {
                label = value?.label_tag;
              }
              return (
                <Tag key={filter.data_index} className={styles.tag}>
                  <div
                    className={`${styles.tagContainer} ${
                      filter.required === true ? styles.centered : ""
                    }`}
                    onClick={() => onHandleTagClick(filter)}
                  >
                    <div>
                      {value?.is_translation && value?.is_translation === true ? t(label) : label}
                    </div>
                    {filter.required === false ? <CloseOutlined className={styles.icon} /> : null}
                  </div>
                </Tag>
              );
            }
            break;
          }
          default:
            break;
        }
        break;
      }
      default:
        break;
    }
  };

  const renderClearButton = () => {
    // const key = filterValue[filter.data_index];
    let haveValue = false;
    Object.keys(filterValue).every((key) => {
      if (filterValue[key] !== null && filterValue[key] !== undefined && filterValue[key] !== "") {
        haveValue = true;
        return false;
      }
      return true;
    });
    if (haveValue === true) {
      return (
        <Tag key={"_clear"} className={styles.tag}>
          <div className={styles.tagContainer} onClick={handleOnReset}>
            <div className={styles.text} style={{ color: "var(--tag-clear-text)" }}>
              {t("mobile.filter.clear.short")}
            </div>
            <ReloadOutlined className={styles.icon} />
          </div>
        </Tag>
      );
    }
  };

  return (
    <div className={styles.container}>
      {filters.map((filter) => renderTag(filter))}
      {renderClearButton()}
    </div>
  );
};

export default FilterTag;
